import styled from 'styled-components';
import background from '../../assets/products/shopBackground.jpg'
import { colors } from "../../utils/colors";

export const Background = styled.div`
    position: relative;
    width: 100%;
    min-height: 100vh;
    background: url(${background});
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const AllProductsTitle = styled.h1`
    color: ${colors.WHITE};
`;

export const TittleWrapper = styled.div`
    text-align: center;
    padding: 0 20px;
    width: 100%;
    max-width: 1200px;
    margin: 150px auto 0;
    position: relative;
`;

export const CreamTitle = styled.span`
    color: ${colors.CREAM};;
`;

export const AllProductsWrapper = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 100px auto 100px;
    padding: 0 20px;
`;

export const CarouselWrapper = styled.div`
    max-width: 1165px;
    margin: 50px auto 100px;
    width: 100%;
    overflow: hidden;

    @media (max-width: 1200px) {
        padding: 0 20px;
    }
`;
